// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { useEffect, useState } from 'react';

/**
 * A React hook that provides a URL for a file object and manages the
 * revocation of the URL.
 *
 * @param file - The file object for which to create the URL.
 */
export function useFileURL(file: File | null) {
  const [fileURL, setFileURL] = useState(() => {
    if (file === null) {
      return null;
    }

    return URL.createObjectURL(file);
  });

  useEffect(() => {
    if (file === null) {
      setFileURL(null);

      return;
    }

    const url = URL.createObjectURL(file);

    setFileURL(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  return fileURL;
}
